/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UpdateWorkPackageDynamicFormsValueRequest } from '../../models/update-work-package-dynamic-forms-value-request';

export interface UpdateWorkPackageDynamicFormsValue$Params {
  id: string;
      body: UpdateWorkPackageDynamicFormsValueRequest
}

export function updateWorkPackageDynamicFormsValue(http: HttpClient, rootUrl: string, params: UpdateWorkPackageDynamicFormsValue$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, updateWorkPackageDynamicFormsValue.PATH, 'put');
  if (params) {
    rb.path('id', params.id, {});
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

updateWorkPackageDynamicFormsValue.PATH = '/v0/workPackages/{id}/dynamic-forms-value';
